<template>
    <BusinessOmniplayEventsSimpleCoreVue :dateDimension="dateDimension" :title="title">
    </BusinessOmniplayEventsSimpleCoreVue>
</template>


<script>


import BusinessOmniplayEventsSimpleCoreVue, { BusinessOmniplayEventsSimpleCore } from '@/views/events/core/BusinessOmniplayEventsSimpleCore.vue';
import { BusinessOmniplayEventsPrestaSimple } from '@/router/routeNames';
import dimensionEnum from '@/model/dimensionEnum';



export default {
    name: BusinessOmniplayEventsPrestaSimple,
    data() {
        return {
            dateDimension: dimensionEnum.OMNIPLAYEVENT_EVENTBUSINESSDATE,
            title: this.$t('title.business_events_presta_simple')
        };
    },
    mounted() {
    },
    computed: {},
    methods: {},
    components: { BusinessOmniplayEventsSimpleCoreVue }
}

</script>